import services from './services';
import {
    lg,
    cloneDeep,
    util,
    isCorrectVal,
    isDate
} from 'utils';
import NProgress from 'nprogress';
import {
    $http
} from '$http';

// 新增 编辑
export default {
    mixins: [services],
    components: {

    },
    data() {
        return {
            AddDialogVisible: false,
            loading: false,
            title: '',
            OrderData: [],
            SchoolInfo: {},
            ClassInfo: {
                TeacherInfo: {}
            },
            FollowInfo: [],
            NetInfo: {},
            SalesInfo: {},
            OrderId: '',
            TabsTypes: [], //tab数组
            TabId: ''
        }
    },
    methods: {
        show(opts) {
            this.AddDialogVisible = true
            this.title = opts.title
            this.OrderId = opts.OrderId
            this.GetById(opts.OrderId)
        },
        changeTab(index) {
            if (index !== '') {
                this.ClassInfo = cloneDeep(this.OrderData.ClassInfo[index].ClassInfo)
                this.FollowInfo = cloneDeep(this.OrderData.ClassInfo[index].FollowInfo)
            }
        },
        //关闭
        close() {
            this.$emit('reloadList')
            this.AddDialogVisible = false
        },

    },
}


// WEBPACK FOOTER //
// ./src/pages/Order/orderViewList/OrderQ2Page/networkDialog/vm.js